/* MSDI professional-use confirmation gate for cart drawer + cart page. Idempotent; loaded from the footer section.
   Also shows the SKU under each cart line (cart drawer + cart page). */
(function () {
  if (window.__msdiProCheck) return;
  window.__msdiProCheck = true;

  var KEY = 'msdi_professional_use';
  var synced = false;
  var scheduled = false;
  var skuMap = {};
  var skuFetching = false;

  function isTicked() {
    try {
      return window.sessionStorage.getItem(KEY) === 'yes';
    } catch (e) {
      return !!window.__msdiProMem;
    }
  }

  function setTicked(v) {
    window.__msdiProMem = v;
    try {
      if (v) window.sessionStorage.setItem(KEY, 'yes');
      else window.sessionStorage.removeItem(KEY);
    } catch (e) {}
  }

  function saveAttribute(v) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { professional_use: v ? 'yes' : '' } })
    })
      .then(function () {
        synced = v;
      })
      .catch(function () {});
  }

  function lockTargets() {
    return document.querySelectorAll(
      '.cart__ctas button[name="checkout"], .cart__ctas .cart__checkout-button, ' +
        '.cart-drawer__summary a[href$="/cart"], .cart__ctas .additional-checkout-buttons'
    );
  }

  function setAttr(el, name, value) {
    if (value === null) {
      if (el.hasAttribute(name)) el.removeAttribute(name);
    } else if (el.getAttribute(name) !== value) {
      el.setAttribute(name, value);
    }
  }

  /* SKU under the product title of every cart line. Data comes from /cart.js (item.sku), keyed by the line key. */
  function paintSku() {
    var rows = document.querySelectorAll('.cart-items__table-row[data-key]');
    var need = false;
    rows.forEach(function (row) {
      var k = row.getAttribute('data-key');
      var info = row.querySelector('.cart-items__product-info');
      if (!k || !info || info.querySelector('.cart-items__sku')) return;
      if (Object.prototype.hasOwnProperty.call(skuMap, k)) {
        if (!skuMap[k]) return;
        var p = document.createElement('p');
        p.className = 'cart-items__sku';
        p.style.cssText = 'margin:2px 0 0;font-size:0.75rem;letter-spacing:0.03em;opacity:0.72;font-variant-numeric:tabular-nums';
        p.textContent = 'SKU ' + skuMap[k];
        var tr = info.querySelector('.cart-items__title-row');
        if (tr && tr.after) tr.after(p);
        else info.insertBefore(p, info.firstChild);
      } else {
        need = true;
      }
    });
    if (need && !skuFetching) {
      skuFetching = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (c) {
          (c.items || []).forEach(function (i) {
            skuMap[i.key] = i.sku || '';
          });
          skuFetching = false;
          paintSku();
        })
        .catch(function () {
          skuFetching = false;
        });
    }
  }

  function apply() {
    scheduled = false;
    var ticked = isTicked();
    var boxes = document.querySelectorAll('input[data-msdi-pro-input]');
    boxes.forEach(function (box) {
      if (box.checked !== ticked) box.checked = ticked;
    });
    var hasBox = boxes.length > 0;
    lockTargets().forEach(function (el) {
      var lock = hasBox && !ticked;
      setAttr(el, 'aria-disabled', lock ? 'true' : null);
      setAttr(el, 'data-msdi-locked', lock ? 'true' : null);
    });
    if (hasBox && ticked && !synced) {
      synced = true;
      saveAttribute(true);
    }
    if (ticked) {
      document.querySelectorAll('[data-msdi-pro-hint]').forEach(function (h) {
        h.hidden = true;
      });
    }
    paintSku();
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(apply);
  }

  function showHint(from) {
    var scope = from.closest('.cart-summary, .cart-drawer__summary, .cart-totals, body') || document;
    var hints = document.querySelectorAll('[data-msdi-pro-hint]');
    hints.forEach(function (h) {
      h.hidden = false;
    });
    var box = document.querySelector('input[data-msdi-pro-input]');
    if (box && scope) box.focus();
  }

  function blockIfLocked(event) {
    var target = event.target && event.target.closest ? event.target.closest('[data-msdi-locked="true"]') : null;
    if (!target) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showHint(target);
  }

  document.addEventListener('click', blockIfLocked, true);

  document.addEventListener(
    'submit',
    function (event) {
      var s = event.submitter;
      if (s && s.getAttribute && s.getAttribute('name') === 'checkout' && s.getAttribute('data-msdi-locked') === 'true') {
        event.preventDefault();
        event.stopImmediatePropagation();
        showHint(s);
      }
    },
    true
  );

  document.addEventListener('change', function (event) {
    var t = event.target;
    if (!t || !t.matches || !t.matches('input[data-msdi-pro-input]')) return;
    setTicked(t.checked);
    synced = false;
    saveAttribute(t.checked);
    apply();
  });

  ['cart:update', 'cart:change', 'cart:refresh'].forEach(function (name) {
    document.addEventListener(name, schedule);
  });

  var observer = new MutationObserver(schedule);

  function start() {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'checked']
    });
    apply();
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();